import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import type { FlagProps } from '../types';
import classes from '../flagpack.module.css';

export function KYFlag({ radius, className, size, ...others }: FlagProps) {
  return (
    <Box
      className={cx(classes.flag, className)}
      __vars={{ '--flag-radius': getRadius(radius), '--flag-size': rem(size) }}
      {...others}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 24">
        <defs>
          <path id="mantine-jpy3gswui" d="M0 0h32v24H0z" />
          <path id="mantine-g5wxd2n9a" d="M0 0h32v24H0z" />
          <path id="mantine-xuvhq4tb4" d="M0 0h18v14H0z" />
          <path
            id="mantine-ajjcl2cpk"
            d="M.008 0v3.722C.008 8.455 3.958 10 4.1 10c.15 0 3.81-1.545 3.81-6.278V0H.008z"
          />
        </defs>
        <g fill="none" fillRule="evenodd">
          <mask id="mantine-6yxk2vtfl" fill="#fff">
            <use xlinkHref="#mantine-jpy3gswui" />
          </mask>
          <g mask="url(#mantine-6yxk2vtfl)">
            <mask id="mantine-svnvtefvl" fill="#fff">
              <use xlinkHref="#mantine-g5wxd2n9a" />
            </mask>
            <use fill="#2E42A5" xlinkHref="#mantine-g5wxd2n9a" />
            <g mask="url(#mantine-svnvtefvl)">
              <mask id="mantine-qxtvxh6ux" fill="#fff">
                <use xlinkHref="#mantine-xuvhq4tb4" />
              </mask>
              <use fill="#2B409A" xlinkHref="#mantine-xuvhq4tb4" />
              <g mask="url(#mantine-qxtvxh6ux)">
                <g fillRule="nonzero">
                  <path
                    fill="#F7FCFF"
                    d="M-2.004 13l3.96 1.737L18.09 1.889l2.09-2.582-4.236-.58-6.58 5.536-5.297 3.73z"
                  />
                  <path fill="#F50100" d="M-1.462 14.217l2.018 1.008L19.429-.933h-2.833z" />
                </g>
                <g fillRule="nonzero">
                  <path
                    fill="#F7FCFF"
                    d="M20.004 13l-3.96 1.737L-.09 1.889-2.18-.693l4.236-.58 6.58 5.536 5.297 3.73z"
                  />
                  <path
                    fill="#F50100"
                    d="M19.87 13.873l-2.019 1.008-8.036-6.917-2.383-.773L-2.38-.684H.453l9.807 7.688 2.605.926z"
                  />
                </g>
                <path
                  fill="#F50100"
                  stroke="#F7FCFF"
                  strokeWidth="1.5"
                  d="M10.735-.75v6h8.015v3.5h-8.016v6h-3.5v-6H-.75v-3.5h7.984v-6h3.5z"
                />
              </g>
            </g>
            <g mask="url(#mantine-svnvtefvl)">
              <g transform="translate(21 11)">
                <mask id="mantine-o6qt2dmrn" fill="#fff">
                  <use xlinkHref="#mantine-ajjcl2cpk" />
                </mask>
                <path
                  fill="#FFF"
                  stroke="#0B50A0"
                  strokeWidth=".1"
                  d="M7.86.05v3.672c0 1.608-.425 2.846-.991 3.778C5.79 9.278 4.197 9.95 4.1 9.95c-.092 0-1.815-.673-2.98-2.46C.513 6.559.058 5.324.058 3.722V.05H7.86z"
                />
                <path
                  stroke="#F7FCFF"
                  strokeWidth=".3"
                  d="M8.06-.15v3.872c0 1.653-.439 2.924-1.02 3.882C5.894 9.49 4.202 10.15 4.1 10.15c-.096 0-1.917-.664-3.147-2.55C.328 6.64-.142 5.37-.142 3.721V-.15H8.06z"
                />
                <path
                  fill="#F50100"
                  fillRule="nonzero"
                  d="M-.5-.5h9v3.4h-9z"
                  mask="url(#mantine-o6qt2dmrn)"
                />
                <path
                  fill="#F50100"
                  fillRule="nonzero"
                  d="M3.512 3.6c.288 0 .864-.313 1.008-.386.528-.313.912-.024 1.224.12.336.145.96.314 1.344 0 .384-.313.6-.289.864-.289C8 2.684 8 2.322 8 1.912v-.29c-.336-.072-.504.025-.864.338-.36.314-.768.241-1.296.049-.504-.217-1.008-.603-1.512 0-.144.168-.48.41-.816.41-.36 0-.672-.242-.816-.41-.528-.603-1.008-.217-1.512 0-.528.192-.96.265-1.32-.049-.336-.313-.504-.41-.864-.337v.29c0 .41.024.77.072 1.132.264 0 .456-.024.84.29.384.313 1.032.144 1.344 0 .336-.145.72-.434 1.248-.12.144.072.696.385 1.008.385z"
                  mask="url(#mantine-o6qt2dmrn)"
                />
                <path
                  fill="#FFD100"
                  d="M1.084 1.049c.144.007.302.098.473.275.257.265 1.203.096 1.203-.063 0-.16-.574-.256-.354-.53C2.626.459 3 .459 3.3.6c.086 0 .077.936.273.884.622-.162 1.625-.485 1.919-.346.387.181.683.136.585-.125-.099-.26-.351-.424-.838-.281-.487.142-.372.281-.793.281-.421 0-1.143.228-.823-.281.288-.457.63-.466.761-.274.067.098-.479.315-.479.416 0 .14 1.407-.274 1.587-.274.18 0 .676-.011.726.132.049.142.348.273.12.406-.228.132-.605.216-.346.386.26.17.916.247.944.424.029.177.311.442.198.442-.113 0-.318.249-.509.173-.19-.076-.213-.142-.03-.204.183-.061.181-.32.03-.32-.15 0-.138-.02-.481-.11-.343-.09-.798-.192-.77 0 .027.191.26.602-.153.64-.413.04-.606.197-.686.07-.08-.126-.367-.295-.142-.349.226-.054.442.184.523.145.081-.039.256-.177.102-.342-.154-.164-.454-.17-.218-.293.236-.123.095-.217-.354.038-.45.255-.7.472-1.094.442-.394-.031-.571.11-.698.068-.127-.042-.745.457-.922.33-.178-.126-.752-.175-.649-.33.103-.156.242-.236.397-.156.154.08.308.16.412.08.104-.08.434-.453.359-.508-.076-.055-.343-.15-.771-.15-.429 0-.439-.284-.54-.414-.068-.087-.02-.137.144-.151z"
                  mask="url(#mantine-o6qt2dmrn)"
                />
                <g fill="#0B50A0" fillRule="nonzero" mask="url(#mantine-o6qt2dmrn)">
                  <path d="M3.512 6c.288 0 .864-.313 1.008-.386.528-.313.912-.024 1.224.12.336.145.96.314 1.344 0 .384-.313.6-.289.864-.289C8 5.084 8 4.722 8 4.312v-.29c-.336-.072-.504.025-.864.338-.36.314-.768.241-1.296.049-.504-.217-1.008-.603-1.512 0-.144.168-.48.41-.816.41-.36 0-.672-.242-.816-.41-.528-.603-1.008-.217-1.512 0-.528.192-.96.265-1.32-.049-.336-.313-.504-.41-.864-.337v.29c0 .41.024.77.072 1.132.264 0 .456-.024.84.29.384.313 1.032.144 1.344 0 .336-.145.72-.434 1.248-.12.144.072.696.385 1.008.385zm0 2.3c.288 0 .864-.313 1.008-.386.528-.313.912-.024 1.224.12.336.145.96.314 1.344 0 .384-.313.6-.289.864-.289C8 7.384 8 7.022 8 6.612v-.29c-.336-.072-.504.025-.864.338-.36.314-.768.241-1.296.049-.504-.217-1.008-.603-1.512 0-.144.168-.48.41-.816.41-.36 0-.672-.242-.816-.41-.528-.603-1.008-.217-1.512 0-.528.192-.96.265-1.32-.049-.336-.313-.504-.41-.864-.337v.29c0 .41.024.77.072 1.132.264 0 .456-.024.84.29.384.313 1.032.144 1.344 0 .336-.145.72-.434 1.248-.12.144.072.696.385 1.008.385z" />
                </g>
                <path
                  fill="#0B50A0"
                  fillRule="nonzero"
                  d="M3.512 10.6c.288 0 .864-.313 1.008-.386.528-.313.912-.024 1.224.12.336.145.96.314 1.344 0 .384-.313.6-.289.864-.289C8 9.684 8 9.322 8 8.912v-.29c-.336-.072-.504.025-.864.338-.36.314-.768.241-1.296.049-.504-.217-1.008-.603-1.512 0-.144.168-.48.41-.816.41-.36 0-.672-.242-.816-.41-.528-.603-1.008-.217-1.512 0-.528.192-.96.265-1.32-.049-.336-.313-.504-.41-.864-.337v.29c0 .41.024.77.072 1.132.264 0 .456-.024.84.29.384.313 1.032.144 1.344 0 .336-.145.72-.434 1.248-.12.144.072.696.385 1.008.385z"
                  mask="url(#mantine-o6qt2dmrn)"
                />
                <path
                  fill="#059334"
                  stroke="#FFD100"
                  strokeWidth=".2"
                  d="M4.042 6.27l.232.536.093.423.19.566-.524-.277-.465.276.136-.574-.448-.414h.589l.197-.537zm-2-2l.232.536.093.423.19.566-.524-.277-.465.276.136-.574-.448-.414h.589l.197-.537zm4 0l.232.536.093.423.19.566-.524-.277-.465.276.136-.574-.448-.414h.589l.197-.537z"
                  mask="url(#mantine-o6qt2dmrn)"
                />
              </g>
              <g fillRule="nonzero">
                <path
                  fill="#FFD100"
                  d="M20.337 20.634c.092.197.75.455 1.516.123.52-.233.857-.565 1.179-1.155.092-.147.137-.332-.077-.442-.168-.099-.444-.21-.566-.307-.062-.05-.123-.086-.169-.123a.6.6 0 01.092.086c.306.295-.015.725-.352.983-.245.184-.69.639-1.332.209-.138-.099-.46.307-.291.626zm9.309 0c-.107.197-.766.455-1.516.123-.52-.233-.857-.565-1.194-1.155-.077-.147-.123-.332.092-.442.168-.099.444-.21.566-.307.062-.05.107-.086.169-.123-.03.024-.062.049-.092.086-.306.295.015.725.337.983.245.184.704.639 1.347.209.138-.099.444.307.291.626z"
                />
                <path
                  fill="#FFD100"
                  d="M24.991 21.691c1.225 0 3.109-.442 4.12-1.99.168-.259 0-.394-.2-.48a2.386 2.386 0 01-.612-.356c.245.197.199.332.03.553-.78 1.044-1.852 1.573-3.338 1.573-1.485 0-2.556-.529-3.337-1.573-.169-.221-.215-.356.015-.553a2.15 2.15 0 01-.612.356c-.2.086-.368.221-.2.48 1.011 1.548 2.91 1.99 4.135 1.99z"
                />
                <path
                  fill="#F50100"
                  d="M22.159 19.614c-.03-.122-.23-.073-.291.074a1.983 1.983 0 01-.214-.27c-.184-.221-.215-.369.046-.578.122-.098.367-.209.535-.086.353.234.169.615-.076.86zm5.65 0c.03-.122.245-.073.306.074.076-.086.153-.172.214-.27.184-.221.215-.369-.061-.578-.107-.098-.352-.209-.536-.086-.337.234-.168.615.077.86z"
                />
              </g>
              <path
                fill="#FFD100"
                fillRule="nonzero"
                d="M27.418 6.291c.019.053-.782.64-1.068 1.311l-.022.056.004.01.065-.055c.79-.634 1.59-.885 1.59-.795 0 .098-.94.56-1.502 1.44l.011.12.001.032.095-.083c.314-.26.596-.36.596-.317 0 .056-.467.328-.718.85-.107.655-.5 1.14-.97 1.14-.458 0-.845-.463-.963-1.094-.244-.553-.737-.839-.737-.896 0-.044.285.058.6.321l.103.092.002-.076.006-.072C23.952 7.383 23 6.917 23 6.818c0-.09.8.16 1.59.795l.074.062-.026-.073c-.268-.627-.983-1.18-1.061-1.293l-.007-.018c.018-.049.741.383 1.323 1.018a.933.933 0 01.328-.25L24.8 6.5h1.5l-.447.596c.09.05.173.12.248.205.58-.63 1.299-1.059 1.317-1.01z"
              />
              <path
                fill="#059334"
                fillRule="nonzero"
                d="M23.424 9.364c-.12-.164-.447-.237-.584-.09-.052.036-.12.036-.172.054-.086 0-.196.046-.162.228.093 0 .093.046.145.046.034-.019.123.316.295.298.19 0 .358.085.392.122.052.054.12.2.034.273a.385.385 0 000 .566c.224.183.791.456 1.427-.073.619-.511 1.581-.219 1.65-.036.086.182.12.292.138.383.017.073.48.182.55.237.086.055.206.037.172-.128-.07-.51-.361-.584-.396-.82.172.017.292.017.361-.056.052-.073.12-.2.19-.237.05-.036.05-.073-.018-.055-.086.019-.137.055-.292.037-.366-.042-.276-1.427-1.486-1.696-.748-.167-1.68.975-1.936 1.088a.133.133 0 01-.016.005.36.36 0 01-.292-.146z"
              />
            </g>
          </g>
        </g>
      </svg>
    </Box>
  );
}
